import { STATISTICS } from 'app/api-routes';
import axios from 'axios';
import { all, put, takeLatest } from 'redux-saga/effects';
import {
  activeIRsGroupedByTypeRequest,
  activeIRsGroupedByTypeSuccess,
  activeIRsGroupedByTypeFailure,
} from './actions';

function* activeIRsGroupedByTypeSaga() {
  try {
    const { payload } = yield axios.get(`${STATISTICS}/incident-reports/active/grouped-by-type`);

    yield put(activeIRsGroupedByTypeSuccess(payload));
  } catch (err) {
    yield put(activeIRsGroupedByTypeFailure(err));
  }
}

export default function* () {
  yield all([yield takeLatest(activeIRsGroupedByTypeRequest, activeIRsGroupedByTypeSaga)]);
}
